export default __webpack_public_path__ + "static/media/english-to-swedish-logo.c082cf38.png";